import {useOperation} from "../use-operation.hook"
import {BusinessView} from "../interfaces/business-view.interface";

export default function useCurrentBusinesses() {
    return useOperation<BusinessView[]>('getBusinessesOfCurrentUser')
}